var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React, { useCallback, useMemo } from "react";
import { useSelector } from "react-redux";
// stylesheets
import "@frameworks/shared-library/stylesheets/components/Aif&PmsSidebar/common.scss";
// components
import InputComponent from "../InputComponent";
import EmpPartnerSearch from "../EmpPartnerSearch";
// helpers
import { floatNumExp } from "@frameworks/web/utils/regex";
import aifPmsDi from "@mainDi/features/AIF-PMS/servicelocator";
var PurchaseFee = function () {
    //
    var _a;
    var paymentProcess = useSelector(function (state) { return state.markets.payment; });
    var purchaseFee = useSelector(function (state) { return state.markets.payment; }).purchaseFee;
    var handleOnChangeInputs = useCallback(function (name, value) {
        var parsedValue = value.trim();
        var updatedValues = __assign({}, paymentProcess.purchaseFee);
        if (name === "setUpFees" || name === "passout") {
            if (!isNaN(Number(parsedValue)) &&
                Number(parsedValue) >= 0 &&
                Number(parsedValue) <= 100) {
                parsedValue = parsedValue.toString();
                updatedValues[name] = parsedValue;
            }
            else {
                updatedValues[name] = "";
            }
        }
        else if (name === "sbName") {
            updatedValues[name] = parsedValue;
        }
        aifPmsDi.payment.updatePurchaseFeeValueProp(updatedValues);
    }, [paymentProcess.purchaseFee]);
    var handleSelectClient = useCallback(function (item) {
        aifPmsDi.payment.updatePurchaseFeeValueProp(__assign(__assign({}, paymentProcess.purchaseFee), { sbName: item }));
    }, [paymentProcess.purchaseFee]);
    var isPurchaseFeeError = useMemo(function () {
        var _a, _b;
        return (((_a = purchaseFee.sbName) === null || _a === void 0 ? void 0 : _a.display_name) &&
            ((_b = purchaseFee.sbName) === null || _b === void 0 ? void 0 : _b.display_name) !== "" &&
            purchaseFee.passout === "");
    }, [(_a = purchaseFee.sbName) === null || _a === void 0 ? void 0 : _a.display_name, purchaseFee.passout]);
    return (React.createElement("div", { className: "d-flex gap-3 flex-column aif-pms-order-book" },
        React.createElement(InputComponent, { label: "Setup Fees %", placeholder: "Enter Setup Fees here", helperText: "", name: "setUpFees", value: String(paymentProcess.purchaseFee.setUpFees), defaultValue: String(paymentProcess.purchaseFee.setUpFees), float: floatNumExp(2), min: 0, max: 100, onChangeEvent: function (event) {
                var _a, _b;
                var value = (_b = (_a = event.target) === null || _a === void 0 ? void 0 : _a.value) !== null && _b !== void 0 ? _b : "";
                handleOnChangeInputs("setUpFees", value);
            } }),
        React.createElement(EmpPartnerSearch, { onSelectClient: handleSelectClient }),
        React.createElement(InputComponent, { label: "Passout %", placeholder: "Enter Passout % here", helperText: "", name: "passout", min: 0, max: 100, value: String(paymentProcess.purchaseFee.passout), defaultValue: String(paymentProcess.purchaseFee.passout), float: floatNumExp(2), onChangeEvent: function (event) {
                var _a, _b;
                var value = (_b = (_a = event.target) === null || _a === void 0 ? void 0 : _a.value) !== null && _b !== void 0 ? _b : "";
                handleOnChangeInputs("passout", value);
            }, isInvalid: isPurchaseFeeError || false })));
};
export default PurchaseFee;
